import noop from 'lodash/noop'
import { MessageModal } from '@/components/message-modal'
import { createModal } from '@/components/modalize/mui'

type MessageModalProps = React.ComponentProps<typeof MessageModal>
type SuccessModalProps = Omit<MessageModalProps, 'onButtonClick' | 'icon'>

export const SuccessModal: React.FC<SuccessModalProps> = ({
  title,
  message,
  buttonText,
  buttonProps = {},
  children,
  onClose = noop
}) => (
  <MessageModal
    title={title}
    message={message}
    buttonText={buttonText}
    buttonProps={buttonProps}
    onClose={onClose}
    children={children}
    icon="round_check"
  />
)

export default SuccessModal

export const show = createModal(SuccessModal, {
  width: '496px',
  clickOutside: false,
  showClose: false
})
